import {
  type JourneyContractSegment,
  JourneyContractSegmentTransportType,
  type TransportData,
} from '@/domainLogic/index.ts';
import type { JourneyDetailContract } from '@lmn/lmn-components';
import { IconTrainline } from '@lmn/lastminute-react-icons/lastminute-icons-solid.js';
import type { IconType } from '@lmn/lastminute-react-icons/lib';
import { IconPlaneNe } from '@/app/common/icons/libraryIcons';

export const createJourneyDetailContract = (transportData: TransportData, locale: string): JourneyDetailContract => {
  const { outbound, inbound } = transportData;
  return {
    locale,
    inbound: {
      ...inbound,
      segments: inbound.segments.map((segment, index) => ({
        ...segment,
        key: `${segment.departure.hub.id}-${segment.arrival.hub.id}-${index}`, // Generate unique key
      })),
    },
    outbound: {
      ...outbound,
      segments: outbound.segments.map((segment, index) => ({
        ...segment,
        key: `${segment.departure.hub.id}-${segment.arrival.hub.id}-${index}`, // Generate unique key
      })),
    },
    seatSelectionMessage: [''],
  };
};

export type MixedWayInfo = {
  firstIcon: IconType;
  secondIcon: IconType;
  thirdIcon?: IconType;
  label: string;
};

export const isMixedWay = (segments: JourneyContractSegment[]): MixedWayInfo | undefined => {
  const isFlight = segments.some((segment) => segment.transport.type === JourneyContractSegmentTransportType.FLIGHT);
  const isTrain = segments.some((segment) => segment.transport.type === JourneyContractSegmentTransportType.TRAIN);

  if (isFlight && isTrain) {
    return {
      firstIcon: IconPlaneNe,
      secondIcon: IconTrainline,
      label: 'widget.trip_card.way.mixed',
    };
  }

  return undefined;
};
